import { render, staticRenderFns } from "./dataCatalog.vue?vue&type=template&id=78c27321&scoped=true&"
import script from "./dataCatalog.vue?vue&type=script&lang=js&"
export * from "./dataCatalog.vue?vue&type=script&lang=js&"
import style0 from "./dataCatalog.vue?vue&type=style&index=0&id=78c27321&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c27321",
  null
  
)

export default component.exports